<template>
  <Question
    :title="isVGCable ? webstoreContent.vehicleCableQuestion.vg.title : webstoreContent.vehicleCableQuestion.ag.title"
    :options="Object.values(isVGCable ? webstoreContent.vehicleCableQuestion.vg.options : webstoreContent.vehicleCableQuestion.ag.options)"
    :selectedOption="selectedTypeOfReplacementCable"
    :cableSelection="true"
    @onOptionClick="setTypeOfReplacementCable"
  >
    <template v-slot:subtitle>
      <p>
          <a id="cable-guide" :href="isVGCable ? webstoreContent.vehicleCableGuide.fields.file.url : webstoreContent.assetCableGuide.fields.file.url" target="_blank">
              {{ isVGCable ? webstoreContent.vehicleCableQuestion.vg.subtitle : webstoreContent.vehicleCableQuestion.ag.subtitle }}
          </a>
      </p>
    </template>
  </Question>
</template>
<script>

import Question from "../../../utils/question";

export default {
  components: {
    Question
  },
  props: {
    webstoreContent: {
      type: Object,
      required: true,
    },
    selectedTypeOfReplacementCable: {
      type: String,
      required: true,
    },
    isVGCable: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    setTypeOfReplacementCable(value) {
      this.$emit('set-selected-cable-type', value)
    },
  },
};
</script>
